import { Field, Widget } from '@kanda-libs/ks-component-ts';
import { Text } from '@kanda-libs/ks-design-library';

import {
  EMPLOYMENT_TYPE_OPTIONS,
  EMPLOYMENT_TYPE_VALIDATION,
  MONTHLY_INCOME_VALIDATION,
  SELF_EMPLOYED_PROPS,
} from './constants';

import { ERROR_PROPS } from '../../PrimaryEmployment/constants';
import useEmploymentStatusFields from '../../PrimaryEmployment/useEmploymentStatusFields';
import EmploymentAddressFields from '../EmploymentAddressFields';
import { MONTHS_OPTIONS } from '../EmploymentMonths/constants';

const SelfEmployedPrimary: React.FunctionComponent = function () {
  const { error, validation, yearsName, monthsName, yearsOptions } =
    useEmploymentStatusFields({
      type: 'primary',
      employmentType: 'self_employed',
      index: undefined,
      arrayName: undefined,
    });
  return (
    <div className="grid grid-cols-2 gap-x-3 md:gap-x-4">
      <Field.Validator validation={EMPLOYMENT_TYPE_VALIDATION}>
        <Field.Select
          {...SELF_EMPLOYED_PROPS.selfEmployedType}
          options={EMPLOYMENT_TYPE_OPTIONS}
        />
      </Field.Validator>
      <Field.Validator validation={MONTHLY_INCOME_VALIDATION}>
        <Field.NumberInput {...SELF_EMPLOYED_PROPS.monthlyIncome} />
      </Field.Validator>

      <Widget.CreditEmploymentDetailsSelfEmployedDetailsBusinessName
        {...SELF_EMPLOYED_PROPS.businessName}
        className="col-span-2 sm:col-span-1 md:col-span-2 xl:col-span-1"
      />
      <Widget.CreditEmploymentDetailsSelfEmployedDetailsTypeOfBusiness
        {...SELF_EMPLOYED_PROPS.typeOfBusiness}
        className="col-span-2 sm:col-span-1 md:col-span-2 xl:col-span-1"
      />
      <div className="col-span-2">
        <EmploymentAddressFields
          employmentStatus="self_employed"
          employmentClass="primary"
        />
      </div>
      <span className="col-span-2 text-12-18-em text-neutral-700 w-full mb-2">
        When did you start your self-employment/business?
      </span>
      <Field.Select
        options={MONTHS_OPTIONS}
        name={monthsName}
        placeholder="Month"
      />
      <Field.Select
        options={yearsOptions}
        name={yearsName}
        placeholder="Year"
      />
      {error && <Text text={error} className={ERROR_PROPS.className} />}
      <div className="hidden">
        <Widget.CreditEmploymentDetailsSelfEmployedDetailsMonthsSelfEmployed
          validation={validation}
        />
      </div>
    </div>
  );
};

export default SelfEmployedPrimary;
